<template>
  <div class="pesquisa_page">
    <v-toolbar  height="auto" color="black"> 
      <div class="d-flex flex-column align-start justify-space-around cont" >
        <img class="diageo" src="../img/logo.png" width="75" alt="Logo Diageo">
       </div>
      <div>
        <v-btn
          icon
          @click="this.handleBack"
        >
          <img class="btnBack" src="../img/right-arrow.png" width="30" alt="Botão voltar" />
        </v-btn>
      </div>
    </v-toolbar>
    <v-row class="mx-auto mt-4" style="width: 90vw; ">
      <v-text-field
        placeholder="O que você está procurando?"
        outlined
        color="#FF8723"
        v-model="strPesquisa"
        dense
         @keyup.enter="reloadBusca()"
      ></v-text-field>
    </v-row>
    <section class="listDrinks px-4 mt-5 ">
      <h1 class="subTitle mb-5">Pesquisando {{strPesquisa}}</h1>
      <v-row> 
        <v-progress-circular
          indeterminate
          class="mx-auto mt-10"
          v-if="loading"
          color="#FF8723"
        ></v-progress-circular>
      </v-row>
      <v-col class="px-0">
        <card-item v-for="x in produtos" :key="x.idItem"  :item="x"></card-item>       
      </v-col>
    </section>
  </div>
</template>

<script>
import "../css/produto.css"
import CardItem from '../components/CardItem.vue'

export default {
  name: 'Pesquisa',
  components: { CardItem
  },
  data() {
    return {
      garrafas: {},
      produtos: [],
      strPesquisa: "",
      loading:false,
    };
  },
  created() { 
    this.loading = true
    this.strPesquisa = this.$route.params.strPesquisa
    this.garrafas = this.$store.state.garrafas
    this.reloadBusca()
  },
  computed: {
    // filteredGarrafas() {
    //   const search = this.strPesquisa.toLowerCase().trim();
    //   if (search == "") return this.garrafasListList
    //   return this.garrafasList.filter(c => c.dsGarrafa.toLowerCase().indexOf(search) > -1);
    // }
  },
  methods:  {
    reloadBusca() { 
      this.loading = true;
      fetch(this.$drink_uri + "/busca-produtos/"+this.strPesquisa.toLowerCase().trim(),
      {headers: {
      'Authorization': `Bearer ${localStorage.tokenDrink}`
    },
      credentials: "include"})
        .then((response) => response.json())
        .then((data) => {
          this.produtos = data;
          this.loading = false;
          this.$forceUpdate();
        });
    },
    changeImg(e) {
      e.target.src = require('../img/garrafa.png') 
    },
    handleBack() {
      this.$router.back();
    }
  }
}
</script>
